/// <reference path="../../app.definition.ts" />

import angular from "angular";
export interface IConfigService {
    get(k?: string, defaultRet?: string): any;
    set(k: string, v: any): void;

    init(): void;
}

export class ConfigService implements IConfigService {
    svcName: string = 'eCareVault.ConfigService';
    config: any;

    static $inject = ["$http"];
    constructor(private $http: ng.IHttpService) {

    }

    init(): void {
        this.config = {
            "allowConfigChanges": true,
            "defaultMugshot": require("../../../assets/images/default_profile_pic.png"),
            "defaultMugshotConf": {
                "size": "48px",
                "initials": false
            },
            "commentBox": {
                "limit": 3,
                "limitIncrement": 3,
                "comment": {
                    "length": 140
                }
            },
            "postBoard": {
                "limit": 3,
                "limitIncrement": 3,
                "order": "DESC"
            },
            "postCharDispMax": 140,
            "postTitleDispMax": 60,
            "defaultThumbnail": "/src/client/assets/images/thumb.png",
            "mugshotSize": {
                "smaller": "20px",
                "small": "30px",
                "medium": "40px",
                "large": "60px",
                "larger": "100px",
                "largest": "130px"
            },
            "mugshotInitialsSize": {
                "smaller": "8pt",
                "small": "10pt",
                "medium": "14pt",
                "large": "22pt",
                "larger": "28pt",
                "largest": "32pt"
            },
            "socketUrl": {
                "ecv-microservices": "https://dev-notifications.ecarevault.com/notifications/get-notification",
                "dev": "https://dev-notifications.ecarevault.com/notifications/get-notification",
                "qa2": "https://qa-notifications.ecarevault.com/notifications/get-notification",
                "staging": "https://staging-notifications.ecarevault.com/notifications/get-notification",
                "my": "https://my-notifications.ecarevault.com/notifications/get-notification",
                "ecv-dev": "https://dev-notifications.ecarevault.com/notifications/get-notification",
                "jeavio-dev": "https://dev-notifications.ecarevault.com/notifications/get-notification"
            },
            "apiPNSSocketUrl": {
                "dev": "dev-websocket.ecarevault.com",
                "qa2": "qa-websocket.ecarevault.com",
                "staging": "staging-websocket.ecarevault.com",
                "my": "my-websocket.ecarevault.com"
            }
        };

    }

    get(k?: string, defaultRet?: any): string {
        return !!k ? (
            !!this.config[k] ? angular.copy(this.config[k]) : (
                !!defaultRet ? defaultRet : null
            )
        ) : this.config;
    }

    set(k: string, v: any): void {
        if (!!k && !!v) {
            if (!!this.config[k] && !!this.config['allowConfigChanges']) {
                console.error(this.svcName + ': Not allowed to change config properties');
            } else {
                console.debug(this.svcName + ': Changing config property "' + k + '" from "' + this.config[k] + '" to "' + v + '"');
                this.config[k] = v;
            }
        } else {
            console.error(this.svcName + ': Could not change property value, missing key or value');
        }
    }
}
angular.module('eCareVault.common.services')
    .service('ConfigService', ConfigService);

